export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LcNgKUsAAAAAIwm38RWA48nvW1htI9AjI0u_zYH',
  },

  //  baseUrl: 'https://localhost:7249/api/'
 /* baseUrl: 'https://njboscreditsuissesettle-dev-azf5djfga9dbh6hu.centralus-01.azurewebsites.net/api/'*/
  baseUrl: 'https://njboscreditsuissesettlement-bra5abe2fvbrawhg.centralus-01.azurewebsites.net/api/' 

};

